import { isObject } from "../_utils/is.js";
const getValueData = (value) => {
  const result = [];
  for (const item of value) {
    if (isObject(item)) {
      result.push(item);
    } else {
      result.push({
        value: item,
        label: String(item),
        closable: true
      });
    }
  }
  return result;
};
export { getValueData };
